import { render, staticRenderFns } from "./ApprovalTextReject.vue?vue&type=template&id=99697e32&"
import script from "./ApprovalTextReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalTextReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports